import React from 'react';
import { array, string } from 'prop-types';
import classNames from 'classnames';
import { map } from 'ramda';

import { ExternalLink, NamedLink } from '../../../components';

import css from './LinkSection.module.css';

const LinkSection = (props) => {
  const { className, headingClassName, linkClassName, headingText, links } = props;
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <h2 className={headingClassName}>{headingText}</h2>
      {map(
        (link) =>
          link.type === 'NamedLink' ? (
            <NamedLink key={link.text} className={linkClassName} {...link.props}>
              {link.text}
            </NamedLink>
          ) : (
            <ExternalLink key={link.text} className={linkClassName} {...link.props}>
              {link.text}
            </ExternalLink>
          ),
        links
      )}
    </div>
  );
};

LinkSection.defaultProps = {
  className: null,
};

LinkSection.propTypes = {
  className: string,
  headingClassName: string.isRequired,
  linkClassName: string.isRequired,
  headingText: string.isRequired,
  links: array.isRequired,
};

export default LinkSection;
